export default __webpack_public_path__ + "static/media/deucesTablePrt.6aaf0de4.webp";